import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6Ld2HYkdAAAAADYWBSXZ4MqAZqSpRePvdxl-WEPd' });


Vue.use(Vuex);

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
const baseURL = 'https://serwis.inchcape.pl/api/';
Vue.axios.defaults.baseURL = baseURL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
